import { all } from "redux-saga/effects";
import { trangThaiKhoSaga } from "./trangThaiKhoSaga";

export default function* quanLyKhoSagaWrapper() {
  yield all([
    trangThaiKhoSaga()
  ]);
}
